module.exports = __webpack_public_path__ + "img/mingzhi_icon_02.dcdc09df.png";